var map = {
	"app/pages/charts/charts.module": [
		"./src/app/pages/charts/charts.module.ts",
		"app-pages-charts-charts-module~app-pages-form-elements-form-elements-module~app-pages-pages-module~a~2abd6515",
		"app-pages-charts-charts-module~app-pages-pages-module",
		"app-pages-charts-charts-module"
	],
	"app/pages/form-elements/form-elements.module": [
		"./src/app/pages/form-elements/form-elements.module.ts",
		"app-pages-form-elements-form-elements-module~app-pages-login-login-module~app-pages-pages-module~app~dd45c0c3",
		"app-pages-charts-charts-module~app-pages-form-elements-form-elements-module~app-pages-pages-module~a~2abd6515",
		"app-pages-form-elements-form-elements-module~app-pages-login-login-module~app-pages-pages-module",
		"app-pages-form-elements-form-elements-module~app-pages-pages-module",
		"app-pages-form-elements-form-elements-module"
	],
	"app/pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"app-pages-form-elements-form-elements-module~app-pages-login-login-module~app-pages-pages-module~app~dd45c0c3",
		"app-pages-form-elements-form-elements-module~app-pages-login-login-module~app-pages-pages-module",
		"app-pages-login-login-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"app-pages-form-elements-form-elements-module~app-pages-login-login-module~app-pages-pages-module~app~dd45c0c3",
		"app-pages-charts-charts-module~app-pages-form-elements-form-elements-module~app-pages-pages-module~a~2abd6515",
		"app-pages-form-elements-form-elements-module~app-pages-login-login-module~app-pages-pages-module",
		"app-pages-charts-charts-module~app-pages-pages-module",
		"app-pages-form-elements-form-elements-module~app-pages-pages-module",
		"app-pages-pages-module"
	],
	"app/pages/register/register.module": [
		"./src/app/pages/register/register.module.ts",
		"app-pages-form-elements-form-elements-module~app-pages-login-login-module~app-pages-pages-module~app~dd45c0c3",
		"app-pages-register-register-module"
	],
	"app/pages/ui/ui.module": [
		"./src/app/pages/ui/ui.module.ts",
		"app-pages-charts-charts-module~app-pages-form-elements-form-elements-module~app-pages-pages-module~a~2abd6515",
		"app-pages-ui-ui-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;